import(/* webpackMode: "eager", webpackExports: ["NotFoundEvent"] */ "/vercel/path0/components/not-found-event.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
